import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Product')
export class Product {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('sku', String, true) sku: string = undefined;
}
